const mutations = {
  nextStep(state) {
    state.step += 1;
  },
  prevStep(state) {
    this.commit('preparation/removeAllExtra');

    if (state.step !== 0) {
      state.step -= 1;
    }
  },
  setStep(state, stepNumber) {
    if (stepNumber > -1) {
      state.step = stepNumber;
    }
  },
  setSessionSettings(state, sessionSettings) {
    state.sessionSettings = sessionSettings;
  },
};

export default mutations;
